import React from 'react'
import './Privacypolicy.css'
function Privacypolicy() {
  let tNCText = "The Bani Bayani app is a talking which uses the 3 major Nigerian " +
  "languages namely: Hausa, Igbo and Yoruba. It is a simple arithmetic calculator " +
  "\n\n\nThe Bani Bayani " +
  "app does not collect or use any user data in any of its modules or in any aspect " +
  "of its operations. User data is not required in any part of the app as such, user " +
  "data is not requested, collected or stored anywhere in the app"
    return (
      <>
        <div className='container termsNCondSection'>

          <div className='headingSection'>
            <h2>Privacy Policy</h2>
          </div>

          <div className='mainBodySection'>
            {tNCText}
          </div>


         </div>
      </>
    )
}

export default Privacypolicy